import { render, staticRenderFns } from "./simpleResult.vue?vue&type=template&id=3aa5be7a&scoped=true&"
import script from "./simpleResult.vue?vue&type=script&lang=js&"
export * from "./simpleResult.vue?vue&type=script&lang=js&"
import style0 from "./simpleResult.vue?vue&type=style&index=0&id=3aa5be7a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa5be7a",
  null
  
)

export default component.exports